module.exports = __webpack_public_path__ + "static/osaka-3-aed47da9733396bd7c4192ae6e3e3c19.png";